module.exports = __webpack_public_path__ + "img/manage-2.dafa900e.png";